import { render, staticRenderFns } from "./selectOrgTreeModal.vue?vue&type=template&id=0fa31754";
import script from "./selectOrgTreeModal.vue?vue&type=script&lang=js";
export * from "./selectOrgTreeModal.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;